<template>
  <div class="header-logo">
    <img class="logo" src="../assets/images/logo.svg">
    <img class="text" src="../assets/images/logo-text.svg">
  </div>
</template>

<script>
  export default {
    name: 'HeaderLogo',
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  @height: 5;
  @mobile-multiplier: 1.7;

  .header-logo {
    height: @height * 1vh;

    @media @vertical {
      height: @height * 1vw;
    }

    @media @mobile {
      height: @height * @mobile-multiplier * 1vh;
    }

    @media @mobile-vertical {
      height: @height * @mobile-multiplier * 1vw;
    }
  }

  img {
    display: inline-block;
    height: 100%;
    box-sizing: border-box;

    &.text {
      @margin-left: 0.5;
      @padding: 0.23;
      @margin-left-mobile: 0.25;

      margin-left: @height * @margin-left * 1vh;
      padding: (@height * @padding * 1vh) 0;

      @media @vertical {
        margin-left: @height * @margin-left * 1vw;
        padding: (@height * @padding * 1vw) 0;
      }

      @media @mobile {
        margin-left: @height * @margin-left-mobile * @mobile-multiplier * 1vh;
        padding: (@height * @padding * @mobile-multiplier * 1vh) 0;
      }

      @media @mobile-vertical {
        margin-left: @height * @margin-left-mobile * @mobile-multiplier * 1vw;
        padding: (@height * @padding * @mobile-multiplier * 1vw) 0;
      }
    }
  }
</style>
